import { useQuery } from "@tanstack/react-query";
import { getCompany } from "@/lib/api";

const DEFAULT_NUMBER = "917370000906"; // fallback
const MESSAGE = "Hi, I'm interested in your electric scooters. Please share more details.";

export default function WhatsAppButton() {
  const { data: company } = useQuery({
    queryKey: ["company"],
    queryFn: getCompany,
  });

  const raw = ((company?.whatsapp || company?.phone) || "").replace(/[^\d]/g, "");
  const number = raw || DEFAULT_NUMBER;
  const href = `https://wa.me/${number}?text=${encodeURIComponent(MESSAGE)}`;

  return (
    <a
      href={href}
      target="_blank"
      rel="noreferrer noopener"
      aria-label="Chat on WhatsApp"
      data-testid="whatsapp-fab"
      className="group fixed z-50 bottom-24 right-6 md:bottom-6 md:right-24 flex items-center gap-2"
    >
      <span
        className="hidden md:inline-flex items-center rounded-full bg-white/90 backdrop-blur-md border border-slate-200 px-3.5 py-1.5 text-xs font-medium text-slate-800 shadow-sm opacity-0 -translate-x-2 group-hover:opacity-100 group-hover:translate-x-0 transition-all"
        aria-hidden
      >
        Chat with us
      </span>
      <span className="relative inline-flex h-14 w-14 items-center justify-center rounded-full bg-[#25D366] text-white shadow-[0_10px_30px_-8px_rgba(37,211,102,0.6)] hover:scale-105 active:scale-95 transition-transform">
        <span className="absolute inset-0 rounded-full bg-[#25D366] opacity-70 animate-ping-slow" aria-hidden />
        <svg
          viewBox="0 0 24 24"
          fill="currentColor"
          className="relative h-7 w-7"
          aria-hidden
        >
          <path d="M17.472 14.382c-.297-.149-1.758-.867-2.03-.967-.273-.099-.471-.148-.67.15-.197.297-.767.966-.94 1.164-.173.199-.347.223-.644.075-.297-.15-1.255-.463-2.39-1.475-.883-.788-1.48-1.761-1.653-2.059-.173-.297-.018-.458.13-.606.134-.133.298-.347.446-.52.149-.174.198-.298.298-.497.099-.198.05-.371-.025-.52-.075-.149-.669-1.612-.916-2.207-.242-.579-.487-.5-.669-.51-.173-.008-.371-.01-.57-.01-.198 0-.52.074-.792.372s-1.04 1.016-1.04 2.479 1.065 2.876 1.213 3.074c.149.198 2.095 3.2 5.076 4.487.709.306 1.263.489 1.694.625.712.227 1.36.195 1.871.118.571-.085 1.758-.719 2.006-1.413.248-.694.248-1.29.173-1.414-.074-.124-.272-.198-.57-.347z"/>
          <path d="M20.52 3.449C18.24 1.245 15.24 0 12.045 0 5.463 0 .104 5.334.101 11.892c0 2.096.549 4.14 1.595 5.945L0 24l6.335-1.652a11.9 11.9 0 005.71 1.447h.006c6.585 0 11.946-5.336 11.949-11.896 0-3.176-1.24-6.165-3.495-8.411l.015-.039zm-8.475 18.297h-.006a9.865 9.865 0 01-5.031-1.378l-.361-.214-3.741.976 1.003-3.638-.235-.374a9.86 9.86 0 01-1.511-5.26c.002-5.45 4.455-9.884 9.929-9.884 2.653 0 5.147 1.032 7.021 2.906a9.876 9.876 0 012.909 6.99c-.002 5.45-4.454 9.876-9.977 9.876z"/>
        </svg>
      </span>
    </a>
  );
}
